import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/mobile/27_clouds/27_clouds"
 * Contains 1 texture(s)
 */
export class Mobile27CloudsAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/mobile/27_clouds/27_clouds';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '27_clouds.jpg'
    ] as const;
}
